export default __webpack_public_path__ + "images/not-emergency.7b9c6d85792dd66119b86d21b4521708.svg";